
/*
*
* Sundae Lane Custom cart drawer, adds two additional hidden "tabs" (when enabled in the sites header in customiser) 
* to the sites cart drawer, clicking links with the matching hash i.e #book or #contact will trigger a click event 
* on the cart to open with the correct matching tab displaying
*
*/
window.theme = window.theme || {};

theme.CustomCartDrawer = (function() {

  function CustomCartDrawer() {

    this.openingCustomTag = false;

    this.bindElements();
    this.bindEvents();
  }

  CustomCartDrawer.prototype = {

    bindElements: function(){
      const self = this;
      self.customCartButtons = document.querySelectorAll('[href*="#"]');
      self.cartButtons = document.querySelectorAll('.js-mini-cart-trigger');
      self.drawerPages = document.querySelectorAll('.mini-cart__container .drawer__content');
      self.cartToggleButton = document.querySelector('.js-mini-cart-trigger');
    },

    bindEvents: function(){
      const self = this;

      self.customCartButtons.forEach(function(button){
        button.addEventListener('click', function(event){
          event.preventDefault();
          self.handleCustomButtonClick(button);
        });
      });

      self.cartButtons.forEach(function(button){
        button.addEventListener('click', function(event){
          if(!self.openingCustomTag){
            self.handleButtonClick(button);
          }
        });
      });

    },

    handleButtonClick: function(){
      const self = this;
      let cartDrawerPage = document.querySelector('.drawer__content--cart');
      if (cartDrawerPage){
        self.drawerPages.forEach(function(drawerPage){
          drawerPage.classList.add('custom--hidden');
        });
      }
      cartDrawerPage.classList.remove('custom--hidden');
    },

    handleCustomButtonClick: function(button){
      const self = this;

      if (!button.hash || button.hash.length == 0){
        return;
      }

      let drawerPageName = button.hash.replace('#','');

      let matchingDrawerPage = document.querySelector('.drawer__content--'+drawerPageName);
      if (matchingDrawerPage){
        self.openingCustomTag = true;
        self.cartToggleButton.click();
        self.drawerPages.forEach(function(drawerPage){
          drawerPage.classList.add('custom--hidden');
        });
        matchingDrawerPage.classList.remove('custom--hidden');
        self.openingCustomTag = false;
      }
      
    }
  }

  return CustomCartDrawer;

})();


document.addEventListener('DOMContentLoaded', function(event) {
  let customDrawerPages = document.querySelectorAll('.drawer__content--custom');
  if (customDrawerPages.length > 0){
    new theme.CustomCartDrawer();
  }
});

